import { Page, type PageConfigMap } from '@/types/schema/page-configs'

import { defaultAccountDetailsConfig } from './account-details'
import { defaultAccountListConfig } from './account-list'
import { defaultAllocationListConfig } from './allocation-list'
import { defaultFilterListConfig } from './filter-list'
import { defaultHoldingListConfig } from './holding-list'
import { defaultModelBuilderConfig } from './model-builder'
import { defaultModelDetailsConfig } from './model-details'
import { defaultModelListConfig } from './model-list'
import { defaultProposalBuilderConfig } from './proposal-builder'
import { defaultProposalsConfig } from './proposals'
import { defaultTradeBlotterConfig } from './trade-blotter'
import { defaultTradeDeskTradeBlotterConfig } from './trade-desk-trade-blotter'
import { defaultUserProfileConfig } from './user-profile'

export const defaultPageConfigs: PageConfigMap = {
  [Page.TradeBlotter]: defaultTradeBlotterConfig,
  [Page.TradeDeskTradeBlotter]: defaultTradeDeskTradeBlotterConfig,
  [Page.HistoricalOrders]: {},
  [Page.AccountList]: defaultAccountListConfig,
  [Page.AccountDetails]: defaultAccountDetailsConfig,
  [Page.AllocationList]: defaultAllocationListConfig,
  [Page.BondDetails]: {},
  [Page.ModelList]: defaultModelListConfig,
  [Page.ModelDetails]: defaultModelDetailsConfig,
  [Page.ModelBuilder]: defaultModelBuilderConfig,
  [Page.Proposals]: defaultProposalsConfig,
  [Page.ProposalBuilder]: defaultProposalBuilderConfig,
  [Page.HoldingList]: defaultHoldingListConfig,
  [Page.FilterList]: defaultFilterListConfig,
  [Page.SleeveManagement]: {},
  [Page.ExecutionRules]: {},
  [Page.UserProfile]: defaultUserProfileConfig,
}
